import { checkAssetTransport } from './assetTransport';
import axios from 'axios';
import { localBackendUrl } from './localBackend';



export const getDesktopOfflineMapStatus = async () => {
  const baseUrl = localBackendUrl();
  if (!baseUrl) {
    return {
      installed: false,
      reason: 'local_backend_unavailable',
      detail: 'Local desktop backend is unavailable.',
    };
  }

  const response = await axios.get(`${baseUrl}/api/desktop/offline-map/status`);
  const status = response.data;
  if (status?.installed && status.tilePath && !status.tileUrl) {
    return {
      ...status,
      tileUrl: `${baseUrl}${status.tilePath}`,
    };
  }
  return status;
};

export const getDesktopOfflineMapUpdateStatus = async (context) => {
  checkAssetTransport(context);
  const baseUrl = context ? context.baseUrl : localBackendUrl();
  if (!baseUrl) {
    return {
      status: 'desktop_unavailable',
      local: {
        installed: false,
        reason: 'local_backend_unavailable',
        detail: 'Local desktop backend is unavailable.',
      },
      published: null,
    };
  }

  const response = await axios.get(`${baseUrl}/api/desktop/offline-map/update-status`, ...(context ? [{ ...context.config, timeout: 30000 }] : []));
  return response.data;
};

export const installDesktopOfflineMap = async (context) => {
  checkAssetTransport(context);
  const baseUrl = context ? context.baseUrl : localBackendUrl();
  if (!baseUrl) {
    throw new Error('Local desktop backend is unavailable');
  }

  const response = await axios.post(`${baseUrl}/api/desktop/offline-map/install`, ...(context ? [undefined, context.config] : []));
  return response.data;
};

export const rollbackDesktopOfflineMap = async (context) => {
  checkAssetTransport(context);
  const baseUrl = context ? context.baseUrl : localBackendUrl();
  if (!baseUrl) {
    throw new Error('Local desktop backend is unavailable');
  }

  const response = await axios.post(`${baseUrl}/api/desktop/offline-map/rollback`, ...(context ? [undefined, context.config] : []));
  return response.data;
};
